import React from 'react';
import PropTypes from 'prop-types';
import DashboardCard from './DashboardCard';
import i18n from '../../src/i18n/translate';

const QuickActionsCard = ({ quickActions }) => {
  const getActionBtnConfig = quickAction => {
    return [
      {
        label: quickAction.urlText,
        style: 'link',
        action: () => { window.open(quickAction.url, quickAction.openInNewTab ? '_blank' : '_self') },
        data: { action: `action-dash-${quickAction.title?.toLowerCase()}`, objectType: 'quick_action' }
      }
    ];
  }

  const visibleActions = quickActions.filter(action => !action.hidden);

  return (
    <DashboardCard 
      type="quick-actions"
      title={i18n.t('Quick Actions')}
      items={visibleActions} 
      emptyComponent={<div>{i18n.t('There are no quick actions available.')}</div>}
      getItemCardProps={quickAction => ({
        title: quickAction.title,
        titleIcon: quickAction.icon,
        description: quickAction.description,
        buttonConfig: getActionBtnConfig(quickAction)
      })}
    />
  );
}

QuickActionsCard.propTypes = {
  quickActions: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    hidden: PropTypes.bool,
    icon: PropTypes.string,
    title: PropTypes.string,
    openInNewTab: PropTypes.bool,
    url: PropTypes.string,
    urlText: PropTypes.string
  })).isRequired
};

QuickActionsCard.defaultProps = {
  quickActions: []
};

export default QuickActionsCard;
